import axios from "axios";
import config from "./config.js";
import store from "../store/";
import { Loading } from "element-ui";
import { REQUEST_URL, APP_KEY } from "src/const/const";
import Message from "common/components/Message";
import { checkToken } from "./token.js";

let count = 0;
const service = axios.create(config);
const requestContinue = 100;
let loadingInstance;
let needToken = true;
const u = window.navigator.userAgent;
const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
if (isIOS) {
  // 判断ios微信
  if (u.indexOf("MicroMessenger") > -1 || u.indexOf("Safari") > -1) {
    needToken = false;
  }
}

// 请求拦截器
service.interceptors.request.use(
  async (config) => {
    const loginType = localStorage.getItem("loginType");
    if (!config.noAuth && needToken) {
      try {
        await checkToken();
      } catch (e) {
        return;
      }
    }
    if (loginType === "iam" && !config.noAppKey) {
      Object.assign(
        config.headers,
        store.state.user.accessToken && (!config || (config && !config.noToken))
          ? {
              Authorization: `Bearer ${store.state.user.accessToken}`,
              appKey: APP_KEY,
            }
          : {
              appKey: APP_KEY,
            }
      );
    }
    if (loginType !== "iam" && !config.noAppKey) {
      Object.assign(
        config.headers,
        localStorage.getItem("token") &&
          (!config || (config && !config.noToken))
          ? {
              token: JSON.parse(localStorage.getItem("token")).token,
              appKey: APP_KEY,
            }
          : {
              appKey: APP_KEY,
            }
      );
    }
    if (config?.showLoading) {
      store.commit("request/UPDATE_ADD_REQUEST_COUNT");
    }
    if (config.formData) {
      config.data = config.formData;
    }
    return config;
  },
  (error) => {
    if (error.config?.showLoading) {
      store.commit("request/UPDATE_SUBTRACT_REQUEST_COUNT");
    }
    return Promise.error(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.config?.showLoading)
      store.commit("request/UPDATE_SUBTRACT_REQUEST_COUNT");
    if (response.status === 200 || response.status === 201) {
      if (response.config.noErrorHandler) return Promise.resolve(response); // 静默接口，不需要错误处理
      switch (response.data.code) {
        case 400:
          return Promise.reject(response.data.msg);
        case 401:
          if (response.config.noLogin) return Promise.reject(response.data.msg);
          Message(response.data.msg);
          setTimeout(() => {
            window.location.reload();
            return Promise.reject(response.data.msg);
          }, 1000);
          break;
        case 30001:
          if (
            response.config.url ===
            "https://dyapi.foxitcloud.cn/printEquipmentShare/getShare"
          ) {
            return Promise.resolve(response);
          }
          Message.error(response.data.msg);
          return Promise.reject(response.data.msg);
        case 40001:
          Message(response.data.msg);
          return Promise.reject(response.data.msg);
        case 40002:
          Message(response.data.msg);
          return Promise.reject(response.data.msg);
        case 40003:
          Message(response.data.msg);
          return Promise.reject(response.data.msg);
        case 40004:
          Message(response.data.msg);
          return Promise.reject(response.data.msg);
        case 40005:
          Message(response.data.msg);
          return Promise.reject(response.data.msg);
        case 50007:
          Message.error(response.data.msg);
          return Promise.reject(response.data.msg);
        case 59999:
          Message.error(response.data.msg);
          return Promise.reject(response.data.msg);
        default:
          return Promise.resolve(response);
      }
    }
    return Promise.reject(response);
  },
  (error) => {
    if (error.config?.showLoading) {
      store.commit("request/UPDATE_SUBTRACT_REQUEST_COUNT");
    }
    // 处理请求超时
    if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
      let config = error.config;
      if (!config || !config.retry) return Promise.reject(error);
      config.__retryCount = config.__retryCount || 0;
      if (config.__retryCount >= config.retry) {
        setTimeout(() => {
          if (store.state.request.requestCount === 0 && loadingInstance)
            loadingInstance.close();
        }, requestContinue);
        Message.error({
          message: "请求超时,请重试!",
        });
        return Promise.reject(error);
      }
      config.__retryCount += 1;
      let backOff = new Promise(function(resolve) {
        setTimeout(function() {
          resolve();
        }, config.retryDelay || 1);
      });
      return backOff.then(function() {
        return service(config);
      });
    }
    setTimeout(() => {
      if (store.state.request.requestCount === 0 && loadingInstance)
        loadingInstance.close();
    }, requestContinue);
    // 异常状态作统一处理
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      error.message = "连接到服务器失败";
    }
    Message.error(error.message);
    // 处理请求失败的情况
    // 对不同返回码对相应处理
    return Promise.reject(error);
  }
);

export default function() {
  return service;
}
